export const FaceAnalyseIcon = ({ className }) => {
  return (
    <svg
      width="142"
      height="174"
      viewBox="0 0 142 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        d="M55.6836 98.8861C61.3651 100.144 60.8917 98.1759 63.7324 98.6494C65.0881 98.8753 65.1988 99.7579 66.5732 99.7579C67.9936 99.7579 67.8413 99.0987 69.414 98.6494C71.0711 98.1759 71.7813 100.144 77.6995 98.8861"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M62.0752 85.7891C62.0752 85.7891 64.4425 88.1564 66.5731 88.1564C68.7036 88.1564 71.3077 85.7891 71.3077 85.7891"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M63.498 106.146C63.498 106.146 65.0762 107.567 66.4966 107.567C67.917 107.567 69.653 106.146 69.653 106.146"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M54.2647 73.242C54.2647 73.242 52.5079 73.8916 50.2402 74.1888C45.3834 74.8254 43.3549 72.0867 38.167 71.1113"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M78.8818 73.242C78.8818 73.242 80.6386 73.8916 82.9062 74.1888C87.7631 74.8254 89.7915 72.0867 94.9795 71.1113"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M77.4629 58.5639C81.724 57.3802 82.9077 56.6766 86.9321 56.6701C92.0269 56.6617 94.7933 57.0367 99.4788 59.0373"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M55.4434 58.3295C51.1822 57.1459 49.9986 56.4423 45.9741 56.4357C40.8794 56.4274 38.113 56.8024 33.4274 58.803"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M20.4122 71.8227C20.4122 71.8227 16.8643 57.4023 17.8082 48.1497C19.1847 34.6561 22.1582 27.1279 30.8283 17.3747C39.4985 7.62159 49.6803 1.53801 64.6801 1.04035C76.6027 0.644792 85.3875 3.11066 94.7449 10.5096C104.924 18.5584 112.974 28.5011 114.63 41.758C116.364 55.6346 112.974 73.0064 112.974 73.0064"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M97.3503 103.072C91.8432 113.218 77.9378 123.898 66.5753 124.614C55.2128 125.331 40.0597 111.594 35.7997 103.072C31.5397 94.5496 28.2236 88.6307 28.2236 65.6679C28.2236 50.6864 39.5867 50.5171 42.6642 44.1254C45.7417 37.7337 51.1865 19.5055 64.9168 21.1626C78.6472 22.8198 77.7003 25.6605 86.2226 31.8155C100.19 36.7868 103.245 49.7372 104.214 63.7746C105.162 77.505 101.848 94.7863 97.3503 103.072Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M53.7909 121.062C53.7909 121.062 52.8245 131.94 48.8195 137.16C43.533 144.051 31.5382 145.682 28.6975 146.629C25.8567 147.576 17.791 148.661 12.3631 152.784C5.80814 157.764 1 170.539 1 170.539"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M79.8312 121.299C79.8312 121.299 80.7975 132.176 84.8025 137.396C90.0891 144.287 102.084 145.919 104.925 146.866C107.765 147.813 115.831 148.897 121.259 153.021C127.814 158.001 132.622 170.775 132.622 170.775"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27.9868 69.2188C27.9868 69.2188 16.3439 69.6922 16.8604 80.5818C17.377 91.4714 32.0074 95.4958 32.0074 95.4958"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M104.683 69.2188C104.683 69.2188 116.326 69.6922 115.809 80.5818C115.293 91.4714 100.662 95.4958 100.662 95.4958"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M64.6846 20.4524C72.7334 14.0607 73.9171 11.9302 76.9945 2.46094"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.6088 58.3427C17.61 43.1236 19.7569 34.8478 24.8599 26.7219L24.9632 26.5574C29.3478 19.5748 36.5319 8.13379 46.0771 4.8755C52.8789 2.55368 64.5711 2.12653 67.972 2.28838C71.373 2.45024 81.923 1.6429 89.8472 4.87517C97.8222 8.12815 99.7172 9.97973 105.005 16.0861C111.054 23.0708 108.463 21.23 114.357 28.129C118.568 33.0569 120.101 37.1197 118.568 44.5141C117.035 51.9086 115.967 54.8626 118.568 60.855C121.169 66.8473 116.012 69.5289 121.701 81.6265C126.147 91.0823 123.234 96.8269 121.701 99.1288C120.168 101.431 114.268 104.911 112.584 117.846C110.9 130.782 120.168 136.788 120.168 148.03C120.168 153.816 115.953 165.277 110.9 171.313C105.847 177.35 111.182 165.855 107.532 158.378C101.637 146.305 95.1813 145.412 89.5305 140.389C83.8797 135.366 76.2459 121.839 82.6239 119.669C89.002 117.5 95.7218 107.245 98.9485 100.206C105.002 87 106.689 82.4892 101.637 71.2784C97.2245 61.4884 101.637 49.719 101.637 49.719C101.637 49.719 99.5764 38.3243 93.9256 34.2792C88.2748 30.234 89.8472 33.7798 83.2518 28.129L83.1304 28.025C77.4859 23.1886 75.0314 21.0855 66.8869 19.9054C58.6957 18.7185 51.1924 24.9304 48.719 30.234C42.4403 43.6972 42.4403 44.3251 36.7894 48.7202C32.9792 51.6837 27.2097 56.2113 27.2097 60.855V74.4677C27.2097 83.755 28.7604 85.1979 31.7277 96.5239C33.5727 103.566 53.1298 118.861 52.502 122C51.8741 125.139 52.4862 134.738 42.4403 141.645C32.3943 148.552 28.5168 145.253 22.9763 148.03C15.2155 151.919 19.9935 161.828 21.6807 173.038C13.2196 166.139 17.6142 166.109 11.5293 158.378C5.44446 150.647 17.6411 146.305 13.2106 128.195C11.507 121.232 17.6172 119.571 17.6172 107.498C17.6172 95.4248 8.15565 88.3441 11.5293 78.8579C14.903 69.3718 17.6081 66.9567 17.6088 58.3427Z"
        fill="black"
        stroke="black"
        strokeWidth="1.2099"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="85.6053"
        cy="91.0974"
        rx="1.56918"
        ry="1.57587"
        fill="#C00000"
      />
      <ellipse
        cx="87.7014"
        cy="95.826"
        rx="1.04612"
        ry="1.05058"
        fill="#C00000"
      />
      <ellipse
        cx="92.1391"
        cy="92.9364"
        rx="0.784592"
        ry="0.787936"
        fill="#C00000"
      />
      <path
        d="M97.6328 77.8477C109.942 77.8477 119.932 87.8706 119.933 100.248C119.933 112.626 109.942 122.649 97.6328 122.649C85.3235 122.649 75.334 112.625 75.334 100.248C75.3342 87.8708 85.3236 77.8479 97.6328 77.8477Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M114.11 117.32L140.001 143.321"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
